import api from './api';

class WalletService {
    async getBalance() {
        try {
            const response = await api.get('/wallet/balance');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    async getTransactions() {
        try {
            const response = await api.get('/wallet/transactions');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }
}

export default new WalletService();